import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from 'axios';
import config from "../../Common/Configurations/APIConfig";
import { handleSuccess, handleError } from "../../Common/Layout/CustomAlerts";
import LayoutHeader from "../../Common/Layout/Header";
import LayoutSideBar from "../../Common/Layout/Sidebar";
import Modal from 'react-bootstrap/Modal';
import ClientRecharge from "./ClientRecharge";
import ChangePassword from "../ChangePassword";
import ClientProfile from "./ClientProfile";
import ClientEmail from "./ClientEmail";
const initialFieldValues = {
    creditUsagePriceId: "00000000-0000-0000-0000-000000000000",
    usage: "",
    totalCount: 0,
    totalCredits: 0
};
export default function ClientSettings() {
    const [profileRefreshKey, setProfileRefreshKey] = useState(0);

    const triggerProfileRefresh = () => {
        setProfileRefreshKey(prev => prev + 1);
    };

    return (
        <div id="layout-wrapper">
            <LayoutHeader key={profileRefreshKey}></LayoutHeader>
            <LayoutSideBar></LayoutSideBar>
            <div className="body-wrapper">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-6">
                            <ClientProfile refreshKey={profileRefreshKey} />
                        </div>
                        <div className="col-6">
                            <ClientRecharge refreshKey={triggerProfileRefresh} />
                        </div>
                        <div className="col-6">
                            <ChangePassword></ChangePassword>
                        </div>
                        <div className="col-6">
                            <ClientEmail></ClientEmail>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}